export enum DemandEntityRecentSearchesLocalStorageKey {
    Collection = "CollectionRecentSearches",
    Customer = "CustomerRecentSearches",
    Order = "OrderRecentSearches",
    Page = "PageRecentSearches",
    Product = "ProductRecentSearches",
}
